export const hours24 = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23,
];
export const hours12 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const meridiems = ["AM", "PM"];
export const minutes = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
export const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
